import { Component, OnInit, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'app-expansion-list',
  templateUrl: './expansion-list.component.html',
  styleUrls: ['./expansion-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ExpansionListComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
